import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import user from './modules/user';
import configNos from './modules/configNos';

Vue.use(Vuex);
const store = new Vuex.Store({

    state: {
        webSocketid:undefined,
        serialid:undefined,
        tcpid:undefined,
    },
    mutations: {

    },
    actions: {

    },
    modules: {
        app,
        user,
        configNos
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js